/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetaIntegrationAdAccountData } from './MetaIntegrationAdAccountData';
import {
    MetaIntegrationAdAccountDataFromJSON,
    MetaIntegrationAdAccountDataFromJSONTyped,
    MetaIntegrationAdAccountDataToJSON,
    MetaIntegrationAdAccountDataToJSONTyped,
} from './MetaIntegrationAdAccountData';
import type { ShoptetIntegrationData } from './ShoptetIntegrationData';
import {
    ShoptetIntegrationDataFromJSON,
    ShoptetIntegrationDataFromJSONTyped,
    ShoptetIntegrationDataToJSON,
    ShoptetIntegrationDataToJSONTyped,
} from './ShoptetIntegrationData';
import type { GoogleDataProviderResourceData } from './GoogleDataProviderResourceData';
import {
    GoogleDataProviderResourceDataFromJSON,
    GoogleDataProviderResourceDataFromJSONTyped,
    GoogleDataProviderResourceDataToJSON,
    GoogleDataProviderResourceDataToJSONTyped,
} from './GoogleDataProviderResourceData';
import type { GoogleIntegrationCustomerClientData } from './GoogleIntegrationCustomerClientData';
import {
    GoogleIntegrationCustomerClientDataFromJSON,
    GoogleIntegrationCustomerClientDataFromJSONTyped,
    GoogleIntegrationCustomerClientDataToJSON,
    GoogleIntegrationCustomerClientDataToJSONTyped,
} from './GoogleIntegrationCustomerClientData';
import type { GoogleDataIntegrationData } from './GoogleDataIntegrationData';
import {
    GoogleDataIntegrationDataFromJSON,
    GoogleDataIntegrationDataFromJSONTyped,
    GoogleDataIntegrationDataToJSON,
    GoogleDataIntegrationDataToJSONTyped,
} from './GoogleDataIntegrationData';
import type { MetaIntegrationData } from './MetaIntegrationData';
import {
    MetaIntegrationDataFromJSON,
    MetaIntegrationDataFromJSONTyped,
    MetaIntegrationDataToJSON,
    MetaIntegrationDataToJSONTyped,
} from './MetaIntegrationData';
import type { PinterestIntegrationAdAccountData } from './PinterestIntegrationAdAccountData';
import {
    PinterestIntegrationAdAccountDataFromJSON,
    PinterestIntegrationAdAccountDataFromJSONTyped,
    PinterestIntegrationAdAccountDataToJSON,
    PinterestIntegrationAdAccountDataToJSONTyped,
} from './PinterestIntegrationAdAccountData';
import type { GoogleIntegrationData } from './GoogleIntegrationData';
import {
    GoogleIntegrationDataFromJSON,
    GoogleIntegrationDataFromJSONTyped,
    GoogleIntegrationDataToJSON,
    GoogleIntegrationDataToJSONTyped,
} from './GoogleIntegrationData';
import type { HeurekaHostNameCredentialData } from './HeurekaHostNameCredentialData';
import {
    HeurekaHostNameCredentialDataFromJSON,
    HeurekaHostNameCredentialDataFromJSONTyped,
    HeurekaHostNameCredentialDataToJSON,
    HeurekaHostNameCredentialDataToJSONTyped,
} from './HeurekaHostNameCredentialData';
import type { SklikIntegrationData } from './SklikIntegrationData';
import {
    SklikIntegrationDataFromJSON,
    SklikIntegrationDataFromJSONTyped,
    SklikIntegrationDataToJSON,
    SklikIntegrationDataToJSONTyped,
} from './SklikIntegrationData';
import type { BsShopIntegrationData } from './BsShopIntegrationData';
import {
    BsShopIntegrationDataFromJSON,
    BsShopIntegrationDataFromJSONTyped,
    BsShopIntegrationDataToJSON,
    BsShopIntegrationDataToJSONTyped,
} from './BsShopIntegrationData';
import type { PinterestIntegrationData } from './PinterestIntegrationData';
import {
    PinterestIntegrationDataFromJSON,
    PinterestIntegrationDataFromJSONTyped,
    PinterestIntegrationDataToJSON,
    PinterestIntegrationDataToJSONTyped,
} from './PinterestIntegrationData';
import type { ShoptetAddonIntegrationData } from './ShoptetAddonIntegrationData';
import {
    ShoptetAddonIntegrationDataFromJSON,
    ShoptetAddonIntegrationDataFromJSONTyped,
    ShoptetAddonIntegrationDataToJSON,
    ShoptetAddonIntegrationDataToJSONTyped,
} from './ShoptetAddonIntegrationData';
import type { MySQLLeadIntegrationData } from './MySQLLeadIntegrationData';
import {
    MySQLLeadIntegrationDataFromJSON,
    MySQLLeadIntegrationDataFromJSONTyped,
    MySQLLeadIntegrationDataToJSON,
    MySQLLeadIntegrationDataToJSONTyped,
} from './MySQLLeadIntegrationData';
import type { HeurekaIntegrationData } from './HeurekaIntegrationData';
import {
    HeurekaIntegrationDataFromJSON,
    HeurekaIntegrationDataFromJSONTyped,
    HeurekaIntegrationDataToJSON,
    HeurekaIntegrationDataToJSONTyped,
} from './HeurekaIntegrationData';
import type { MicrosoftIntegrationData } from './MicrosoftIntegrationData';
import {
    MicrosoftIntegrationDataFromJSON,
    MicrosoftIntegrationDataFromJSONTyped,
    MicrosoftIntegrationDataToJSON,
    MicrosoftIntegrationDataToJSONTyped,
} from './MicrosoftIntegrationData';
import type { MicrosoftIntegrationCustomerData } from './MicrosoftIntegrationCustomerData';
import {
    MicrosoftIntegrationCustomerDataFromJSON,
    MicrosoftIntegrationCustomerDataFromJSONTyped,
    MicrosoftIntegrationCustomerDataToJSON,
    MicrosoftIntegrationCustomerDataToJSONTyped,
} from './MicrosoftIntegrationCustomerData';
import type { UpgatesIntegrationData } from './UpgatesIntegrationData';
import {
    UpgatesIntegrationDataFromJSON,
    UpgatesIntegrationDataFromJSONTyped,
    UpgatesIntegrationDataToJSON,
    UpgatesIntegrationDataToJSONTyped,
} from './UpgatesIntegrationData';

/**
 * 
 * @export
 * @interface ListProjectIntegrations200ResponseInner
 */
export interface ListProjectIntegrations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    lastHistoricalUpdate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    paused?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    project?: string;
    /**
     * 
     * @type {Array<MetaIntegrationAdAccountData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    metaIntegrationAdAccounts?: Array<MetaIntegrationAdAccountData>;
    /**
     * 
     * @type {boolean}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    accessTokenConfigured?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    scope?: string;
    /**
     * 
     * @type {Array<GoogleIntegrationCustomerClientData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    googleIntegrationCustomerClients?: Array<GoogleIntegrationCustomerClientData>;
    /**
     * 
     * @type {boolean}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    refreshTokenConfigured?: boolean;
    /**
     * 
     * @type {ListProjectIntegrations200ResponseInnerIntegrationTypeEnum}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    integrationType?: ListProjectIntegrations200ResponseInnerIntegrationTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    grantedScopes?: Array<string>;
    /**
     * 
     * @type {any}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    accessTokenExpiresAt?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    hasEnabledProviderResources?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    readyForScheduler?: boolean;
    /**
     * 
     * @type {Array<GoogleDataProviderResourceData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    providerResources?: Array<GoogleDataProviderResourceData>;
    /**
     * 
     * @type {Array<GoogleDataProviderResourceData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    availableProviderResources?: Array<GoogleDataProviderResourceData>;
    /**
     * 
     * @type {Array<MicrosoftIntegrationCustomerData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    microsoftIntegrationCustomers?: Array<MicrosoftIntegrationCustomerData>;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    pinterestUserId?: string;
    /**
     * 
     * @type {any}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    refreshTokenExpiresAt?: any | null;
    /**
     * 
     * @type {Array<PinterestIntegrationAdAccountData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    pinterestIntegrationAdAccounts?: Array<PinterestIntegrationAdAccountData>;
    /**
     * 
     * @type {boolean}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    apiKeyConfigured?: boolean;
    /**
     * 
     * @type {Array<HeurekaHostNameCredentialData>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    hostNameAndApiKeyList?: Array<HeurekaHostNameCredentialData>;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    databaseName?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    tableName?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    customWhere?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    categoryColumns?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnCountry?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnVerified?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmSource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmMedium?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmContent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnClickId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmCampaign?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmCampaignId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmAdSetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    columnUtmAdSetAdId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    passwordConfigured?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    knownStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    unpaidOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    completedOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    refundedOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    hostNameList?: Array<string>;
    /**
     * 
     * @type {ListProjectIntegrations200ResponseInnerStatusEnum}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    status: ListProjectIntegrations200ResponseInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    eshopUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    skippedEmailAddressList?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    knownCentres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    b2cCentres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListProjectIntegrations200ResponseInner
     */
    b2bCentres?: Array<string>;
}


/**
 * @export
 */
export const ListProjectIntegrations200ResponseInnerIntegrationTypeEnum = {
    Merchant: 'merchant',
    Analytics: 'analytics',
    SearchConsole: 'search-console',
    Bigquery: 'bigquery'
} as const;
export type ListProjectIntegrations200ResponseInnerIntegrationTypeEnum = typeof ListProjectIntegrations200ResponseInnerIntegrationTypeEnum[keyof typeof ListProjectIntegrations200ResponseInnerIntegrationTypeEnum];

/**
 * @export
 */
export const ListProjectIntegrations200ResponseInnerStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Paused: 'paused'
} as const;
export type ListProjectIntegrations200ResponseInnerStatusEnum = typeof ListProjectIntegrations200ResponseInnerStatusEnum[keyof typeof ListProjectIntegrations200ResponseInnerStatusEnum];


/**
 * Check if a given object implements the ListProjectIntegrations200ResponseInner interface.
 */
export function instanceOfListProjectIntegrations200ResponseInner(value: object): value is ListProjectIntegrations200ResponseInner {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('eshopUrl' in value) || value['eshopUrl'] === undefined) return false;
    return true;
}

export function ListProjectIntegrations200ResponseInnerFromJSON(json: any): ListProjectIntegrations200ResponseInner {
    return ListProjectIntegrations200ResponseInnerFromJSONTyped(json, false);
}

export function ListProjectIntegrations200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListProjectIntegrations200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] === undefined ? undefined : json['lastRegularUpdate'] === null ? null : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] === undefined ? undefined : json['lastHistoricalUpdate'] === null ? null : json['lastHistoricalUpdate'],
        'paused': json['paused'] == null ? undefined : json['paused'],
        'project': json['project'] == null ? undefined : json['project'],
        'metaIntegrationAdAccounts': json['metaIntegrationAdAccounts'] == null ? undefined : ((json['metaIntegrationAdAccounts'] as Array<any>).map(MetaIntegrationAdAccountDataFromJSON)),
        'accessTokenConfigured': json['accessTokenConfigured'] == null ? undefined : json['accessTokenConfigured'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'googleIntegrationCustomerClients': json['googleIntegrationCustomerClients'] == null ? undefined : ((json['googleIntegrationCustomerClients'] as Array<any>).map(GoogleIntegrationCustomerClientDataFromJSON)),
        'refreshTokenConfigured': json['refreshTokenConfigured'] == null ? undefined : json['refreshTokenConfigured'],
        'integrationType': json['integrationType'] == null ? undefined : json['integrationType'],
        'grantedScopes': json['grantedScopes'] == null ? undefined : json['grantedScopes'],
        'accessTokenExpiresAt': json['accessTokenExpiresAt'] === undefined ? undefined : json['accessTokenExpiresAt'] === null ? null : json['accessTokenExpiresAt'],
        'hasEnabledProviderResources': json['hasEnabledProviderResources'] == null ? undefined : json['hasEnabledProviderResources'],
        'readyForScheduler': json['readyForScheduler'] == null ? undefined : json['readyForScheduler'],
        'providerResources': json['providerResources'] == null ? undefined : ((json['providerResources'] as Array<any>).map(GoogleDataProviderResourceDataFromJSON)),
        'availableProviderResources': json['availableProviderResources'] == null ? undefined : ((json['availableProviderResources'] as Array<any>).map(GoogleDataProviderResourceDataFromJSON)),
        'microsoftIntegrationCustomers': json['microsoftIntegrationCustomers'] == null ? undefined : ((json['microsoftIntegrationCustomers'] as Array<any>).map(MicrosoftIntegrationCustomerDataFromJSON)),
        'pinterestUserId': json['pinterestUserId'] == null ? undefined : json['pinterestUserId'],
        'refreshTokenExpiresAt': json['refreshTokenExpiresAt'] === undefined ? undefined : json['refreshTokenExpiresAt'] === null ? null : json['refreshTokenExpiresAt'],
        'pinterestIntegrationAdAccounts': json['pinterestIntegrationAdAccounts'] == null ? undefined : ((json['pinterestIntegrationAdAccounts'] as Array<any>).map(PinterestIntegrationAdAccountDataFromJSON)),
        'apiKeyConfigured': json['apiKeyConfigured'] == null ? undefined : json['apiKeyConfigured'],
        'hostNameAndApiKeyList': json['hostNameAndApiKeyList'] == null ? undefined : ((json['hostNameAndApiKeyList'] as Array<any>).map(HeurekaHostNameCredentialDataFromJSON)),
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'port': json['port'] == null ? undefined : json['port'],
        'username': json['username'] == null ? undefined : json['username'],
        'databaseName': json['databaseName'] == null ? undefined : json['databaseName'],
        'tableName': json['tableName'] == null ? undefined : json['tableName'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'customWhere': json['customWhere'] === undefined ? undefined : json['customWhere'] === null ? null : json['customWhere'],
        'categoryColumns': json['categoryColumns'] === undefined ? undefined : json['categoryColumns'] === null ? null : json['categoryColumns'],
        'columnDate': json['columnDate'] == null ? undefined : json['columnDate'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'columnCountry': json['columnCountry'] === undefined ? undefined : json['columnCountry'] === null ? null : json['columnCountry'],
        'columnVerified': json['columnVerified'] === undefined ? undefined : json['columnVerified'] === null ? null : json['columnVerified'],
        'columnUtmSource': json['columnUtmSource'] === undefined ? undefined : json['columnUtmSource'] === null ? null : json['columnUtmSource'],
        'columnUtmMedium': json['columnUtmMedium'] === undefined ? undefined : json['columnUtmMedium'] === null ? null : json['columnUtmMedium'],
        'columnUtmContent': json['columnUtmContent'] === undefined ? undefined : json['columnUtmContent'] === null ? null : json['columnUtmContent'],
        'columnClickId': json['columnClickId'] === undefined ? undefined : json['columnClickId'] === null ? null : json['columnClickId'],
        'columnUtmCampaign': json['columnUtmCampaign'] === undefined ? undefined : json['columnUtmCampaign'] === null ? null : json['columnUtmCampaign'],
        'columnUtmCampaignId': json['columnUtmCampaignId'] === undefined ? undefined : json['columnUtmCampaignId'] === null ? null : json['columnUtmCampaignId'],
        'columnUtmAdSetId': json['columnUtmAdSetId'] === undefined ? undefined : json['columnUtmAdSetId'] === null ? null : json['columnUtmAdSetId'],
        'columnUtmAdSetAdId': json['columnUtmAdSetAdId'] === undefined ? undefined : json['columnUtmAdSetAdId'] === null ? null : json['columnUtmAdSetAdId'],
        'passwordConfigured': json['passwordConfigured'] == null ? undefined : json['passwordConfigured'],
        'knownStatuses': json['knownStatuses'] == null ? undefined : json['knownStatuses'],
        'unpaidOrderStatuses': json['unpaidOrderStatuses'] == null ? undefined : json['unpaidOrderStatuses'],
        'completedOrderStatuses': json['completedOrderStatuses'] == null ? undefined : json['completedOrderStatuses'],
        'refundedOrderStatuses': json['refundedOrderStatuses'] == null ? undefined : json['refundedOrderStatuses'],
        'hostNameList': json['hostNameList'] == null ? undefined : json['hostNameList'],
        'status': json['status'],
        'eshopUrl': json['eshopUrl'],
        'skippedEmailAddressList': json['skippedEmailAddressList'] == null ? undefined : json['skippedEmailAddressList'],
        'knownCentres': json['knownCentres'] == null ? undefined : json['knownCentres'],
        'b2cCentres': json['b2cCentres'] == null ? undefined : json['b2cCentres'],
        'b2bCentres': json['b2bCentres'] == null ? undefined : json['b2bCentres'],
    };
}

export function ListProjectIntegrations200ResponseInnerToJSON(json: any): ListProjectIntegrations200ResponseInner {
    return ListProjectIntegrations200ResponseInnerToJSONTyped(json, false);
}

export function ListProjectIntegrations200ResponseInnerToJSONTyped(value?: ListProjectIntegrations200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
        'paused': value['paused'],
        'project': value['project'],
        'metaIntegrationAdAccounts': value['metaIntegrationAdAccounts'] == null ? undefined : ((value['metaIntegrationAdAccounts'] as Array<any>).map(MetaIntegrationAdAccountDataToJSON)),
        'accessTokenConfigured': value['accessTokenConfigured'],
        'scope': value['scope'],
        'googleIntegrationCustomerClients': value['googleIntegrationCustomerClients'] == null ? undefined : ((value['googleIntegrationCustomerClients'] as Array<any>).map(GoogleIntegrationCustomerClientDataToJSON)),
        'refreshTokenConfigured': value['refreshTokenConfigured'],
        'integrationType': value['integrationType'],
        'grantedScopes': value['grantedScopes'],
        'accessTokenExpiresAt': value['accessTokenExpiresAt'],
        'hasEnabledProviderResources': value['hasEnabledProviderResources'],
        'readyForScheduler': value['readyForScheduler'],
        'providerResources': value['providerResources'] == null ? undefined : ((value['providerResources'] as Array<any>).map(GoogleDataProviderResourceDataToJSON)),
        'availableProviderResources': value['availableProviderResources'] == null ? undefined : ((value['availableProviderResources'] as Array<any>).map(GoogleDataProviderResourceDataToJSON)),
        'microsoftIntegrationCustomers': value['microsoftIntegrationCustomers'] == null ? undefined : ((value['microsoftIntegrationCustomers'] as Array<any>).map(MicrosoftIntegrationCustomerDataToJSON)),
        'pinterestUserId': value['pinterestUserId'],
        'refreshTokenExpiresAt': value['refreshTokenExpiresAt'],
        'pinterestIntegrationAdAccounts': value['pinterestIntegrationAdAccounts'] == null ? undefined : ((value['pinterestIntegrationAdAccounts'] as Array<any>).map(PinterestIntegrationAdAccountDataToJSON)),
        'apiKeyConfigured': value['apiKeyConfigured'],
        'hostNameAndApiKeyList': value['hostNameAndApiKeyList'] == null ? undefined : ((value['hostNameAndApiKeyList'] as Array<any>).map(HeurekaHostNameCredentialDataToJSON)),
        'hostname': value['hostname'],
        'port': value['port'],
        'username': value['username'],
        'databaseName': value['databaseName'],
        'tableName': value['tableName'],
        'domain': value['domain'],
        'customWhere': value['customWhere'],
        'categoryColumns': value['categoryColumns'],
        'columnDate': value['columnDate'],
        'timeZone': value['timeZone'],
        'columnCountry': value['columnCountry'],
        'columnVerified': value['columnVerified'],
        'columnUtmSource': value['columnUtmSource'],
        'columnUtmMedium': value['columnUtmMedium'],
        'columnUtmContent': value['columnUtmContent'],
        'columnClickId': value['columnClickId'],
        'columnUtmCampaign': value['columnUtmCampaign'],
        'columnUtmCampaignId': value['columnUtmCampaignId'],
        'columnUtmAdSetId': value['columnUtmAdSetId'],
        'columnUtmAdSetAdId': value['columnUtmAdSetAdId'],
        'passwordConfigured': value['passwordConfigured'],
        'knownStatuses': value['knownStatuses'],
        'unpaidOrderStatuses': value['unpaidOrderStatuses'],
        'completedOrderStatuses': value['completedOrderStatuses'],
        'refundedOrderStatuses': value['refundedOrderStatuses'],
        'hostNameList': value['hostNameList'],
        'status': value['status'],
        'eshopUrl': value['eshopUrl'],
        'skippedEmailAddressList': value['skippedEmailAddressList'],
        'knownCentres': value['knownCentres'],
        'b2cCentres': value['b2cCentres'],
        'b2bCentres': value['b2bCentres'],
    };
}

